"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScalarComparison = void 0;
const value_comparison_1 = require("../../Comparison/value-comparison");
const comparison_spec_1 = require("../comparison-spec");
class ScalarComparison extends comparison_spec_1.ComparisonSpec {
    constructor(key, normalizeValue) {
        super();
        this.key = key;
        this.normalizeValue = normalizeValue;
        this.alignment = new comparison_spec_1.CellAlignment(['key'], ['value']);
        this.membershipContestable = false;
    }
    toRows(data) {
        return [{ key: this.key, value: data }];
    }
    fromRows(rows) {
        const [row] = rows;
        if (row === undefined) {
            throw new Error(`Cannot reconstruct scalar '${this.key}' from zero rows.`);
        }
        return row.value;
    }
    rowKeyOf(row) {
        return (0, value_comparison_1.compositeKey)(row, this.alignment.keyColumns.map(String), (column, value, rowContext) => this.normalize(column, value, rowContext));
    }
    normalize(column, value, row) {
        if (column === 'value' && this.normalizeValue !== undefined) {
            return this.normalizeValue(value);
        }
        return super.normalize(column, value, row);
    }
}
exports.ScalarComparison = ScalarComparison;
//# sourceMappingURL=scalar.comparison.js.map